import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { colorGray } from 'styles/layout/colors';
const IconReviews = t0 => {
  const $ = _c(9);
  const {
    className: t1,
    color: t2,
    height: t3,
    width: t4
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const color = t2 === undefined ? colorGray : t2;
  const height = t3 === undefined ? 48 : t3;
  const width = t4 === undefined ? 48 : t4;
  let t5;
  let t6;
  if ($[0] !== color) {
    t5 = <path d="M37.0554 18.109H32.6152L33.0251 17.7105C33.5246 17.2239 33.6868 16.4867 33.4392 15.8349C33.193 15.1832 32.5825 14.7392 31.8866 14.705L27.6745 14.5229L25.6822 10.0488C25.4018 9.41127 24.7728 9 24.077 9C23.3811 9 22.7521 9.41127 22.4718 10.0488L20.4794 14.5229L16.2786 14.6936C15.5827 14.7278 14.9722 15.1718 14.726 15.8236C14.4784 16.4753 14.6407 17.2125 15.1402 17.6992L15.5386 18.109H11.0985C8.8372 18.1147 7.00583 19.9462 7 22.2075V34.5028C7.00569 36.7641 8.8372 38.5955 11.0985 38.6013H37.0553C39.3166 38.5956 41.148 36.7641 41.1538 34.5028V22.2075C41.1481 19.9462 39.3166 18.1148 37.0553 18.109L37.0554 18.109ZM20.5818 16.7998C21.4499 16.7656 22.2226 16.2391 22.5741 15.445L24.0769 12.0296L25.5797 15.445C25.9312 16.2391 26.7039 16.7656 27.572 16.7998L30.5662 16.9705L28.2892 19.1792C27.747 19.7043 27.4994 20.4628 27.6289 21.2056L28.1754 24.3819L25.2951 22.5262C24.5466 22.0452 23.5846 22.0452 22.836 22.5262L19.9557 24.3705L20.5022 21.2056C20.6317 20.4628 20.3841 19.7043 19.8419 19.1792L17.5877 16.9705L20.5818 16.7998ZM38.8769 34.5029C38.8769 34.9853 38.6848 35.4493 38.3433 35.7908C38.0018 36.1324 37.5379 36.3245 37.0554 36.3245H11.0985C10.0924 36.3245 9.27699 35.509 9.27699 34.5029V22.2076C9.27699 21.2014 10.0924 20.386 11.0985 20.386H17.9293L18.3278 20.7731L17.5764 25.1105C17.4625 25.7979 17.7614 26.4866 18.3392 26.8752C18.9198 27.2566 19.6711 27.2566 20.2518 26.8752L24.077 24.4047L27.9591 26.8866C28.5425 27.2594 29.2882 27.2594 29.8717 26.8866C30.4494 26.4981 30.7483 25.8093 30.6345 25.1219L29.8945 20.7728L30.2816 20.3972H37.0555C38.0573 20.3972 38.8713 21.2055 38.877 22.2073L38.8769 34.5029Z" fill={color} />;
    t6 = <path d="M28.6309 31.3984H19.5232C18.8942 31.3984 18.3848 31.9079 18.3848 32.5369C18.3848 33.1659 18.8942 33.6754 19.5232 33.6754H28.6309C29.2599 33.6754 29.7694 33.1659 29.7694 32.5369C29.7694 31.9079 29.2599 31.3984 28.6309 31.3984Z" fill={color} />;
    $[0] = color;
    $[1] = t5;
    $[2] = t6;
  } else {
    t5 = $[1];
    t6 = $[2];
  }
  let t7;
  if ($[3] !== className || $[4] !== height || $[5] !== t5 || $[6] !== t6 || $[7] !== width) {
    t7 = <svg className={className} fill="none" height={height} viewBox="0 0 48 48" width={width}>{t5}{t6}</svg>;
    $[3] = className;
    $[4] = height;
    $[5] = t5;
    $[6] = t6;
    $[7] = width;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  return t7;
};
IconReviews.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number
};
export default IconReviews;